module.exports = __webpack_public_path__ + "img/100-0cc3fb.png";